module.exports = __webpack_public_path__ + "img/victorious-mobile-player.02f3fbe1.jpg";